export const LAST_CONFERENCE_CONFIG_KEY = 'lastConferenceConfig';
export const SESSION_STORAGE_EMAIL_KEY = 'feedback-email';
export const SESSION_STORAGE_DESCRIPTION_KEY = 'feedback-description';
export const VIRTUAL_BACKGROUND_TYPE_KEY = 'virtual-background-type';
export const NOISE_CANCELLATION_TYPE = 'noiseCancellationType';
export const NOISE_CANCELLATION_TYPE_YANDEX = 'noiseCancellationTypeYandex';
